import {createAsyncThunk} from "@reduxjs/toolkit";
import {DesignStatus} from "src/enums/design-status";
import axios from "src/axios";
import biLoggingService, {ErrorReportData, SeverityType} from 'src/services/bi-logging/bi-logging.service';

const errorMessage = 'Set design status failed.';
export const sendDesignStatusAsync = createAsyncThunk('design/setDesignStatus',
    async ( args: { orderId: string;
        csmMessageId: string; companyId: number; bizContextBase64: string, status: DesignStatus;
        message: string}, thunkAPI) => {
        try {
            const response = await axios.post(`3d-preview/${args.orderId}/${args.csmMessageId}`,
                {
                    companyId: args.companyId,
                    status: args.status,
                    note: args.message
                }, {
                    headers: {
                        'X-ITERO-BIZCTX': args.bizContextBase64,
                    },
                });
            return response.data;
        } catch (e) {
            const errorData: ErrorReportData = {
                object: errorMessage,
                code: '',
                description: errorMessage,
                severity: SeverityType.Error
            }
            biLoggingService.sendErrorReport(errorData);
            return thunkAPI.rejectWithValue(errorMessage);
        }
    });
